import React, { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth.jsx'
import { sage, fonts } from '../styles/theme.js'

export default function OAuthCallback() {
  const { signIn } = useAuth()
  const navigate = useNavigate()
  const called = useRef(false)

  useEffect(() => {
    if (called.current) return
    called.current = true
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    const error = params.get('error')
    if (error) { navigate(`/?error=${encodeURIComponent(error)}`); return }
    if (!token) { navigate('/?error=no_token'); return }
    signIn(token)
    navigate('/cover', { replace: true })
  }, []) // eslint-disable-line

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: sage.faint,
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: 44, height: 44, border: `3px solid ${sage.mid}`,
          borderTopColor: 'transparent', borderRadius: '50%',
          animation: 'spin 0.9s linear infinite', margin: '0 auto 16px',
        }} />
        <p style={{ color: sage.dark, fontFamily: fonts.serif, fontSize: 16, fontWeight: 500 }}>
          Signing you in…
        </p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  )
}
